import React from "react"

import SelectGenericNew from "../../../../../../gd-ui/select-generic-new/select-generic-new"
import {futureOptions} from "../../../../../../gd/const/automation/days-options";
import {FieldAutomationActionFormProps} from "../../../../../render/automation-action-form";
import WeekdaysPicker from "../../../../../../gd-components/datetime/weekdays-picker/weekdays-picker";
import {BinaryWeek, DaysOfWeek} from "../../../../../../gd/types/types";
import workweekToDaysOfWeek from "../../../../../../gd/convert/workweek-to-days-of-week";
import daysOfWeekToWorkweek from "../../../../../../gd/convert/days-of-week-to-workweek";

const debug = false
// const debug = "DateActionForm"

type State = {
    toValue         : any | null,
    weekdays        : BinaryWeek
}

export default class FieldDate_AutomationActionForm extends React.Component<FieldAutomationActionFormProps,State> {

    constructor(props:FieldAutomationActionFormProps) {
        super(props)

        this.state = {
            toValue         : _.get(props.config, 'toValue', null),
            weekdays        : _.get(props.config, 'weekdays', [1,1,1,1,1,1,1])
        }

    }

    onChangeDaysOfWeek = (daysOfWeek: DaysOfWeek) => {

        const weekdays = daysOfWeekToWorkweek(daysOfWeek)


        this.setState({
            weekdays : weekdays
        }, ()=>{
            this.props.onChangeCallback({
                toValue     : this.state.toValue,
                weekdays    : weekdays
            })
        })

    }

    onChangeValue = (option:Option) => {
        const toValue = option.value

        this.setState({
            toValue : toValue
        }, ()=>{
            this.props.onChangeCallback({
                toValue     : toValue
            })
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        const daysOfWeek = workweekToDaysOfWeek(this.state.weekdays)

        return (
            <React.Fragment>
                <div className="flex-column-left-top">

                    <div className="flex-row-left-top">
                        <div className={labelClasses}>to</div>
                        <SelectGenericNew className="selector w-180"
                                          options={futureOptions}
                                          value={this.state.toValue}
                                          popoverScrollContainerClasses="max-h-200"
                                          scrollToSelected={true}
                                          disabled={this.props.config.disabled}
                                          onChange={this.onChangeValue}/>
                    </div>

                    <div className="flex-row-left-top m-t-20">
                        <div className={labelClasses}>Days of the week:</div>

                        <WeekdaysPicker value={daysOfWeek} onChange={this.onChangeDaysOfWeek} />

                    </div>

                </div>


            </React.Fragment>
        )
    }
}